var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isMarked)?_c('span',{staticClass:"text-danger",attrs:{"title":_vm.title}},[_vm._v("*")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }